var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"sitemap"},[_c('AccesskeyLink',{staticClass:"accesskey-c",attrs:{"id":"mainContent","accesskey":"C","title":":::主要內容顯示區"}}),_c('ArticleSitemap')],1)}
var staticRenderFns = []

export { render, staticRenderFns }